import getLabStudies from "@custom/rtk-apis/labStudies/getLabStudies";
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  status:"",
  result:null,
  msg:"",
  loading:false,
  error:""
};

const getLabStudiesSlice = createSlice({
  name: "getLabStudiesSlice",
  initialState,
  reducers: {
    clearLabStudies: state => {
      state.status = '';
      state.result = '';
      state.msg = '';
      state.loading = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getLabStudies.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(getLabStudies.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.status = payload.status;
        state.result = payload.result;
        state.msg = payload.msg;
      })
      .addCase(getLabStudies.rejected, (state, { payload }) => {
        state.result = payload;
        state.loading = false;
      });
  },
});

export default getLabStudiesSlice.reducer;
export const { clearLabStudies } = getLabStudiesSlice.actions;
